import { View } from "binder"
import { DebitCardSelectorViewModel } from "./debitCardSelector-viewModel";
import { DebitPaymentViewModel } from "./debitPayment-viewModel"

export class DebitPaymentView extends View<DebitPaymentViewModel>{
    GetViewUniqueId(): string {
        return "V-85C1B466-043E-4E5E-819B-D0211718BBE4"
    }
    loadHtml(): string {
        let element = require('./debitPayment.html').default;
        let style = require('./debitPayment.less');
        return element;
    }
    constructor() {
       super();
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    public set debitCardSelectorViewModel(v: DebitCardSelectorViewModel) { this._debitCardSelectorViewModel = v; } public get debitCardSelectorViewModel(): DebitCardSelectorViewModel { return this._debitCardSelectorViewModel;} private _debitCardSelectorViewModel: DebitCardSelectorViewModel;
    public set maxAmount(v: number) { this._maxAmount = v; } public get maxAmount(): number { return this._maxAmount;} private _maxAmount: number;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount;} private _amount: number;
    public set cardNo(v: string) { this._cardNo = v; } public get cardNo(): string { return this._cardNo;} private _cardNo: string;
    public set traceCode(v: string) { this._traceCode = v; } public get traceCode(): string { return this._traceCode;} private _traceCode: string;
    public set invoiceId(v: string) { this._invoiceId = v; } public get invoiceId(): string { return this._invoiceId;} private _invoiceId: string;
    public set isAmountInvalid(v: boolean) { this._isAmountInvalid = v; } public get isAmountInvalid(): boolean { return this._isAmountInvalid;} private _isAmountInvalid: boolean;
    public set paymentTime(v: moment.Moment) { this._paymentTime = v; } public get paymentTime(): moment.Moment { return this._paymentTime;} private _paymentTime: moment.Moment;
    
}
